<body>
    <div class="container-fluid bg-transparent jumbotron">
        <div class="container bg-transparent justify-content-center  mt-5 mb-5 p-5">
            <div class="row">
                <div [ngClass]="!isMobile ? 'column1 text-left ml-5' : 'column1 text-center'">
                    <div [ngClass]="!isMobile ? 'col-md-8' : ''">
                        <div class="page-title ">Changing Lives.</div>
                        <div class="page-title ">One Household at a Time.</div>
                     </div>
                     <div [ngClass]="!isMobile ? 'col-md-10 mt-3' : 'mt-3'">
                        <div class="page-text ">Welcome to Sacwaitlist.com - a Sacramento Housing and Redevelopment Agency (SHRA) website.</div>
                     </div>
                     <div  [ngClass]="!isMobile ? 'col-md-8 mt-3 mb-5' : 'mt-3 mb-5'">
                        <button type="button" (click)="login()" class="btn btn-general">Sign In</button>
                     </div>
                </div>

                <div [ngClass]="!isMobile ? 'column1 mr-5' : ''">
                    <div *ngIf="userstatus">
                        <div *ngIf="userstatus == 'error'">
                            <p class="text-center page-text text-danger">Registration confirmation failed.</p>
                        </div>
                        <div *ngIf="userstatus == 'success'">
                            <p class="text-center page-text">Registration confirmation is successful. Click <a href="javascript:void(0)" (click)="login()">here</a> to login</p>
                        </div>
                        <div *ngIf="userstatus == 'expired'">
                            <p class="text-center page-text text-danger">Link expired. <a href="javascript:void(0)" (click)="resendConfirmationLink()">Resend</a> a confirmation link</p>
                        </div>
                        <div *ngIf="userstatus == 'resent'">
                            <p class="text-center page-text">An email with a confirmation link is sent to your email address. Please use the link to confirm your registration.</p> 
                        </div>
                        <div *ngIf="userstatus == 'resent error'">
                            <p class="text-center page-text text-danger">Resend confirmation link failed. Invalid account</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ngx-spinner bdcolor="rgba(51,51,51,0.8)" size="default" type="ball-spin-clockwise">
            <p style="color: white;">Please wait.</p>
        </ngx-spinner>
    </div>
</body>